


<div class="example-loading-shade" *ngIf="showSpinner">
  <mat-spinner *ngIf="showSpinner"></mat-spinner>
</div>


<div class="example-loading-shade" *ngIf="showSuccess">
  <mat-card [className]="mySpeechBubble" >
      <div style="padding-left: 30%">
        <div [className]="myClassName"></div>
      </div>
      <div class="titleFont" style="padding-top: 30px">{{headerIn}}</div>
      <div class="messageFont" style="padding-top: 10px">{{messageIn}}</div>
      <div *ngIf="myClassName=='trouble'" style="padding-top: 25px; padding-left: 12px; padding-right: 12px">
        <button  class="upperFonts" (click)="confirmHit()" style="color:black; width: 50%;  font-size: 20px ">Confirm</button>
        <button class="upperFonts" (click)="cancelButton()" style="color:black; width: 50%; font-size: 20px ">Cancel</button>
      </div>


  </mat-card>
</div>



<mat-toolbar mat-toolbar class="toolbar2" id="noPrint" *ngIf="!underMaint">
  <mat-toolbar-row>
   <button *ngIf="!showLogin && phoneApp" mat-button (click)="openMenus()" class="upperFonts" style="color:black;  font-size: 18px; min-width: min-content "><img  src="assets/menu-24px.svg" >Menu</button>
    <div *ngIf="menusFound && !showLogin">
      <app-menus [myMenus]="navItems" ></app-menus>
    </div>


    <span class="example-fill-remaining-space" *ngIf="!showLogin && phoneApp && userObj.role=='MISC' && userObj.company_code=='M0995'"></span>
    <button *ngIf="!showLogin && phoneApp && userObj.role=='MISC' && userObj.company_code=='M0995'" mat-button (click)="showTruckerScreen()" class="upperFonts" style="color:black;  font-size: 18px; min-width: min-content "><img  src="assets/home.svg" >Home</button>

   <div *ngIf="!showLogin">
     <table class="nameRole" >
       <td >
         <span class="upperFonts" style="padding-left:10%; color:black; font-size: 20px; font-weight: bolder">{{fullName}}</span>
       </td>
       <tr style="line-height: 2px">
         <td >
           <span class="upperFonts" style="color:black; padding-left: 10%; font-size: 15px; font-weight: lighter">{{roleIn}}</span>
         </td>
       </tr>
     </table>
   </div>


    <span class="example-fill-remaining-space"></span>
      <span *ngIf="!phoneApp">
            <span *ngIf="navItems!=null && navItems.length>0" routerLink="charts">
                      <button  mat-raised-button class="blueButton" (click)="hideMenus()"  style="background: transparent; color: black; box-shadow: none"><img style="height: 20px; width: 20px; padding-right: 5px; vertical-align: sub " src="assets/home.svg" >Home</button>
            </span>

            <span  *ngFor="let child of navItems" >
              <span style="padding-right: 15px">
                      <button  mat-raised-button class="blueButton" (click)="showMenu(child.children)" style="background: transparent; color: black; box-shadow: none"><img style="height: 20px; width: 20px; padding-right: 5px; vertical-align: sub " [src]="child.iconName" >{{child.displayName}}</button>
              </span>
            </span>
            <span *ngIf="navItems!=null && navItems.length>0" routerLink="reports">
                      <button  mat-raised-button class="blueButton" (click)="hideMenus()"  style="background: transparent; color: black; box-shadow: none"><img style="height: 20px; width: 20px; padding-right: 5px; vertical-align: sub " src="assets/print-24px.svg" >Reports</button>
            </span>
      </span>

    <span class="example-fill-remaining-space"></span>




    <div>
      <button mat-button (click)="showHideHelp()" *ngIf="!showLogin  &&  this.myHelp!=null" class="menuButtons" ><img  [src]="this.myHelp.iconName" >Help</button>

      <mat-accordion class="helpAcc"  displayMode="flat" *ngIf="!showLogin  &&  this.myHelp!=null" matRippleDisabled >
        <mat-expansion-panel #helpPanel class="mat-elevation-z0" hideToggle>


              <span *ngFor="let children of myHelp.children" >
                    <mat-card style="background-color: rgba(26,47,75,0.7)">
                      <div *ngIf="children.route!='contact'">
                        <a style="color: white" target="_blank" [href]="children.route">
                                <button mat-button  style="width: 100%; color: white; text-align: left;  font-size: 17px; text-shadow:2px 2px 2px black; "><img style="height: 20px; width: 20px; padding-right: 10px; " src="assets/menu.png" >{{children.displayName}}</button>
                        </a>
                    </div>
                    <div *ngIf="children.route=='contact'">
                        <a style="color: white"  [routerLink] ="children.route">
                                <button mat-button (click)="showHideHelp()"  style="width: 100%; color: white; text-align: left;  font-size: 17px; text-shadow:2px 2px 2px black; "><img style="height: 20px; width: 20px; padding-right: 10px; " src="assets/menu.png" >{{children.displayName}}</button>
                        </a>
                    </div>

                    </mat-card>
              </span>
        </mat-expansion-panel>
      </mat-accordion>

    </div>

    <div>
      <button mat-button (click)="showHideAccount()" *ngIf="!showLogin  && this.myAccount!=null" class="menuButtons" ><img  [src]="this.myAccount.iconName" >My Account</button>
      <mat-accordion class="accountAcc"  displayMode="flat" *ngIf="!showLogin  && this.myAccount!=null" matRippleDisabled >
        <mat-expansion-panel #accPanel class="mat-elevation-z0" hideToggle>
          <span *ngFor="let children of myAccount.children" >
            <mat-card style="background-color: rgba(26,47,75,0.7)">
              <div>
                 <a style="color: white"  [routerLink]="children.route">
                   <button mat-button (click)="closeAcctPanel()"   style="width: 100%; color: white; text-align: left;  font-size: 17px; text-shadow:2px 2px 2px black; "><img style="height: 20px; width: 20px; padding-right: 10px; " src="assets/menu.png" >{{children.displayName}}</button>
                 </a>
              </div>
            </mat-card>
          </span>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <a style="color: white" target="_blank" href="https://n4.maherterminals.com/apex/n4.zul">
      <button mat-button  class="upperFonts visibleToScreen"  style="color:black; font-size: 18px " matTooltip="Steamship Lines ONLY">Navis N4</button>
    </a>
    <button mat-button *ngIf="showLogin" (click)="signUp()" class="upperFonts" style="color:black; font-size: 18px ">Sign Up</button>
    <button mat-raised-button *ngIf="!showLogin" (click)="logout()"  class="blueButton" style="background: rgba(26,47,75,0.7)">Logout</button>
  </mat-toolbar-row>
</mat-toolbar>



<mat-card id="menuCanvas" class="menuSystem"   [style]="varIn2" *ngIf="showMenuItems">
      <span *ngFor="let children of navChildren" >
          <mat-card style="background-color: rgba(26,47,75,0.7); padding: 10px; padding-left: 20px; padding-right: 20px; padding: 16px;" >
            <div>
                  <button mat-button (click)="hideMenus()" [routerLink]="children.route" style=" padding: 0px; width: 100%; color: white; text-align: left; font-size: 17px; text-shadow: black; font-weight: lighter; line-height: 14px;     text-shadow: 2px 2px 2px black;"  ><img style="height: 19px; width: 22px; padding-right: 10px; " src="assets/menu.png"  > {{children.displayName | titlecase}}</button>
            </div>
          </mat-card>
      </span>

</mat-card>






<div >

    <router-outlet></router-outlet>
</div>



<div style="background: transparent;">

</div>







